import Renderable from '../../../Component/Renderable';
import ElementComponent from '../../../Component/UI/Element';
import GameObject from '../../../GameObject/GameObject';
import { GameObjectEvent } from '../../../GameObject/GameObjectEvent';
import WorldHudIcon from '../../../Prototype/UI/WorldHudIcon';
import { IGameState } from '../../../State/Game/IGameState';
import { UIActions } from '../../../State/UI/UIActions';
import Point from '../../../Utility/Point';
import BaseUISystem from '../BaseUISystem';
import BaseUIHandler from '../BaseUIHandler';
import WorldHUDHandler from './WorldHUDHandler';
import { applyDefaultButtonAnimation } from '../UIHelper';
import { AUDIO_UI_BUTTON_DEFAULT } from '../../Audio';

export default class ShopHUD extends BaseUIHandler {
    private btnShop: WorldHudIcon;

    constructor(uiSystem: BaseUISystem) {
        super('botOptInHUD', uiSystem, false);
        this.alwaysVisible = true;
    }

    public handleStateChanged(state: IGameState): void {
        if (!this.btnShop || this.btnShop.destroyed) return;

        this.btnShop.getComponent(Renderable).visible =
            state.platform.IAPSupport;
    }

    protected onCreate(): void {
        const hud: WorldHUDHandler = this.system.handlers.find(
            handler => handler instanceof WorldHUDHandler
        ) as WorldHUDHandler;

        if (!hud) return;

        this.btnShop = GameObject.Instantiate(WorldHudIcon, {
            name: 'shopIcon',
            key: 'button_shop',
            rays: false,
        });

        const container = hud.element.find('bottom_container');
        if (!container) return;
        container.addChild(this.btnShop);

        this.btnShop.on(GameObjectEvent.SELECTED, () => {
            this.system.state.dispatch(UIActions.showPopup('shopMenu'));
        });
        applyDefaultButtonAnimation(this.btnShop, AUDIO_UI_BUTTON_DEFAULT);

        const btnElement = this.btnShop.getComponent(ElementComponent);

        btnElement.offsetTopLeft = new Point(150, btnElement.offsetTopLeft.y);
        btnElement.offsetBottomRight = new Point(
            150,
            btnElement.offsetBottomRight.y
        );
    }
}
